// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-panel-container {
  width: 100%;
  padding: 20px;
  background-color: #f5f5f5;
}

.table-title {
  font-size: 24px;
  font-weight: bold;
  color: #4caf50;
  margin-bottom: 20px;
}

.reports-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  max-width: 350px;
  height: 57%;
}

.table-header {
  text-align: left;
  background-color: #dff0d8;
  color: #333333;
  padding: 10px;
  font-weight: bold;
}

.table-cell {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
  color: #333333;
  text-align: left;
}

.table-cell:hover {
  background-color: #f2f2f2;
  cursor: pointer;
}

.admin-panel-layout {
  display: flex;
  /* height: 100vh; */
}

.admin-panel-menu {
  width: 20%;
  border-right: 1px solid #ddd;
  padding: 1rem;
  background-color: #f9f9f9;
  height: 500px;
}

.admin-panel-content {
  flex: 1 1;
  padding: 1rem;
  background-color: #ffffff;
  width: 80%;
  /* border: 1px solid black; */
  height: 495px;
  margin: 0px 5px 5px 10px;
}
.reports-table tr:nth-child(odd) {
  /* border: 1px solid #000; */
  background-color: white;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .admin-panel-layout {
    display: flex;
    /* height: 100vh; */
  }
  .admin-panel-menu {
    width: 20%;
    border-right: 1px solid #ddd;
    padding: 1rem;
    background-color: #f9f9f9;
    height: 487px;
  }
  .table-title {
    font-size: 20px;
    font-weight: bold;
    color: #4caf50;
    margin-bottom: 20px;
  }
  .reports-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #ffffff;
    max-width: 350px;
  }
  .reports-table tbody tr:nth-child(odd) {
    /* border: 1px solid #000; */
    background-color: white;
  }
  .table-header {
    text-align: left;
    background-color: #dff0d8;
    color: #333333;
    padding: 7px;
    font-weight: bold;
  }
  .admin-panel-content {
    flex: 1 1;
    padding: 1rem;
    background-color: #ffffff;
    width: 80%;
    /* border: 1px solid black; */
    height: 495px;
    margin: 0px 5px 5px 10px;
  }

  .leave-report-container {
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
    padding: 25px;
    background-color: #f8f9fa;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    max-width: 950px;
    margin: -10px;
    position: relative;
    overflow: scroll;
    height: 435px;
  }
  .leave-report-form {
    display: flex;
    justify-content: space-between;
    gap: 30px;
    flex-wrap: wrap;
  }
}

@media screen and (min-width: 1440px) {
  .admin-panel-layout {
    display: flex;
    /* height: 100vh; */
  }
  .admin-panel-menu {
    width: 20%;
    border-right: 1px solid #ddd;
    padding: 1rem;
    background-color: #f9f9f9;
    height: 487px;
  }
  .table-title {
    font-size: 20px;
    font-weight: bold;
    color: #4caf50;
    margin-bottom: 20px;
  }
  .reports-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #ffffff;
    max-width: 350px;
  }
  .reports-table tbody tr:nth-child(odd) {
    /* border: 1px solid #000; */
    background-color: white;
  }
  .table-header {
    text-align: left;
    background-color: #dff0d8;
    color: #333333;
    padding: 7px;
    font-weight: bold;
  }
  .admin-panel-content {
    flex: 1 1;
    padding: 1rem;
    background-color: #ffffff;
    width: 80%;
    /* border: 1px solid black; */
    height: 495px;
    margin: 0px 5px 5px 10px;
  }

  .leave-report-container {
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
    padding: 25px;
    background-color: #f8f9fa;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    max-width: 950px;
    margin: -10px;
    position: relative;
    overflow: scroll;
    height: 435px;
  }
  .leave-report-form {
    display: flex;
    justify-content: space-between;
    gap: 30px;
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/AdminPanel.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,4BAA4B;IAC5B,aAAa;IACb,yBAAyB;IACzB,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,6BAA6B;IAC7B,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,4DAA4D;IAC5D,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,4BAA4B;IAC5B,aAAa;IACb,yBAAyB;IACzB,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,6BAA6B;IAC7B,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,4DAA4D;IAC5D,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[".admin-panel-container {\n  width: 100%;\n  padding: 20px;\n  background-color: #f5f5f5;\n}\n\n.table-title {\n  font-size: 24px;\n  font-weight: bold;\n  color: #4caf50;\n  margin-bottom: 20px;\n}\n\n.reports-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #ffffff;\n  max-width: 350px;\n  height: 57%;\n}\n\n.table-header {\n  text-align: left;\n  background-color: #dff0d8;\n  color: #333333;\n  padding: 10px;\n  font-weight: bold;\n}\n\n.table-cell {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n  color: #333333;\n  text-align: left;\n}\n\n.table-cell:hover {\n  background-color: #f2f2f2;\n  cursor: pointer;\n}\n\n.admin-panel-layout {\n  display: flex;\n  /* height: 100vh; */\n}\n\n.admin-panel-menu {\n  width: 20%;\n  border-right: 1px solid #ddd;\n  padding: 1rem;\n  background-color: #f9f9f9;\n  height: 500px;\n}\n\n.admin-panel-content {\n  flex: 1;\n  padding: 1rem;\n  background-color: #ffffff;\n  width: 80%;\n  /* border: 1px solid black; */\n  height: 495px;\n  margin: 0px 5px 5px 10px;\n}\n.reports-table tr:nth-child(odd) {\n  /* border: 1px solid #000; */\n  background-color: white;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .admin-panel-layout {\n    display: flex;\n    /* height: 100vh; */\n  }\n  .admin-panel-menu {\n    width: 20%;\n    border-right: 1px solid #ddd;\n    padding: 1rem;\n    background-color: #f9f9f9;\n    height: 487px;\n  }\n  .table-title {\n    font-size: 20px;\n    font-weight: bold;\n    color: #4caf50;\n    margin-bottom: 20px;\n  }\n  .reports-table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: #ffffff;\n    max-width: 350px;\n  }\n  .reports-table tbody tr:nth-child(odd) {\n    /* border: 1px solid #000; */\n    background-color: white;\n  }\n  .table-header {\n    text-align: left;\n    background-color: #dff0d8;\n    color: #333333;\n    padding: 7px;\n    font-weight: bold;\n  }\n  .admin-panel-content {\n    flex: 1 1;\n    padding: 1rem;\n    background-color: #ffffff;\n    width: 80%;\n    /* border: 1px solid black; */\n    height: 495px;\n    margin: 0px 5px 5px 10px;\n  }\n\n  .leave-report-container {\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n    padding: 25px;\n    background-color: #f8f9fa;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    max-width: 950px;\n    margin: -10px;\n    position: relative;\n    overflow: scroll;\n    height: 435px;\n  }\n  .leave-report-form {\n    display: flex;\n    justify-content: space-between;\n    gap: 30px;\n    flex-wrap: wrap;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .admin-panel-layout {\n    display: flex;\n    /* height: 100vh; */\n  }\n  .admin-panel-menu {\n    width: 20%;\n    border-right: 1px solid #ddd;\n    padding: 1rem;\n    background-color: #f9f9f9;\n    height: 487px;\n  }\n  .table-title {\n    font-size: 20px;\n    font-weight: bold;\n    color: #4caf50;\n    margin-bottom: 20px;\n  }\n  .reports-table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: #ffffff;\n    max-width: 350px;\n  }\n  .reports-table tbody tr:nth-child(odd) {\n    /* border: 1px solid #000; */\n    background-color: white;\n  }\n  .table-header {\n    text-align: left;\n    background-color: #dff0d8;\n    color: #333333;\n    padding: 7px;\n    font-weight: bold;\n  }\n  .admin-panel-content {\n    flex: 1 1;\n    padding: 1rem;\n    background-color: #ffffff;\n    width: 80%;\n    /* border: 1px solid black; */\n    height: 495px;\n    margin: 0px 5px 5px 10px;\n  }\n\n  .leave-report-container {\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n    padding: 25px;\n    background-color: #f8f9fa;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    max-width: 950px;\n    margin: -10px;\n    position: relative;\n    overflow: scroll;\n    height: 435px;\n  }\n  .leave-report-form {\n    display: flex;\n    justify-content: space-between;\n    gap: 30px;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
